var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 3.54167L13.4583 13.4583L3.54167 13.4583L3.54167 3.54167L13.4583 3.54167ZM13.4583 2.125L3.54167 2.125C2.7625 2.125 2.125 2.7625 2.125 3.54167L2.125 13.4583C2.125 14.2375 2.7625 14.875 3.54167 14.875L13.4583 14.875C14.2375 14.875 14.875 14.2375 14.875 13.4583L14.875 3.54167C14.875 2.7625 14.2375 2.125 13.4583 2.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91634 12.0423L4.95801 12.0423L4.95801 10.6257L9.91634 10.6257L9.91634 12.0423ZM12.0413 9.20898L4.95801 9.20898L4.95801 7.79232L12.0413 7.79232L12.0413 9.20898ZM12.0413 6.37565L4.95801 6.37565L4.95801 4.95898L12.0413 4.95898L12.0413 6.37565Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSheet);
export default __webpack_public_path__ + "static/media/dashboard-sheet.3fa6bb53b480818904fe77556197b235.svg";
export { ForwardRef as ReactComponent };